import type {PropsWithChildren} from 'react'
import {createContext, useContext, useMemo} from 'react'
import type {Comparison} from '../page-data/payloads/files'

interface SelectedRefContextData {
  startOid?: string | null
  endOid?: string | null
  baseRefOid?: string
}

export const SelectedRefContext = createContext<SelectedRefContextData>({})

export function SelectedRefContextProvider({comparison, children}: PropsWithChildren<{comparison: Comparison}>) {
  const value = useMemo(() => {
    const startOid = comparison.selectedRange?.baseOid
    const endOid = comparison.selectedRange?.headOid
    const baseRefOid = comparison.fullDiff.baseOid

    return {
      endOid,
      startOid,
      baseRefOid,
    }
  }, [comparison.selectedRange?.baseOid, comparison.selectedRange?.headOid, comparison.fullDiff.baseOid])

  return <SelectedRefContext.Provider value={value}>{children}</SelectedRefContext.Provider>
}

export const useSelectedRefContext = () => useContext(SelectedRefContext)

export function useHasCommitRange() {
  const {endOid, startOid} = useSelectedRefContext()
  return !!endOid || !!startOid
}

try{ SelectedRefContext.displayName ||= 'SelectedRefContext' } catch {}
try{ SelectedRefContextProvider.displayName ||= 'SelectedRefContextProvider' } catch {}